export enum ModalTabs {
  All = 'All',
  Responses = 'Responses',
  Social = 'Social',
  Uploads = 'Uploads',
}
